import { NavLink } from 'react-router-dom';
import { Building2 } from 'lucide-react';

const sections = [{
    route: '/admin/tenants',
    label: 'Tenants',
    icon: Building2,
}];

const AdminSidebar = () => {
    return (
        <nav className="w-56 shrink-0 border-r border-gray-200 bg-white px-3 py-6">
            <p className="mb-3 px-3 text-[11px] font-semibold uppercase tracking-wider text-gray-400">
                Plataforma
            </p>
            <ul className="space-y-1">
                {sections.map(({ route, label, icon: Icon }) => (
                    <li key={route}>
                        <NavLink
                            to={route}
                            className={({ isActive }) =>
                                `flex items-center gap-2.5 rounded-md px-3 py-2 text-sm transition-colors ${isActive
                                    ? 'bg-brand-primary font-semibold text-white'
                                    : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                                }`
                            }
                        >
                            <Icon size={16} />
                            {label}
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default AdminSidebar;
